import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/transaction/user-requests'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        request(context, { data, config }) {
            return base.request.put(`${baseUrl}/request`, data, { ...config })
        },
        requestApproveRegister(context, { data, config }) {
            return base.request.put(`${baseUrl}/approve-register`, data, { ...config });
        },
        requestNotApproveRegister(context, { data, config }) {
            return base.request.put(`${baseUrl}/not-approve-register`, data, { ...config });
        },
        RegisterFisherman(context, { data, config }) {
            return base.request.post(`${baseUrl}/register`, data, { ...config });
        },
        RegisterManager(context, { data, config }) {
            return base.request.post(`${baseUrl}/register-officer`, data, { ...config });
        },
        registerPeople(context, { data, config }) {
            return base.request.post(`${baseUrl}/register-people`, data, { ...config });
        },
        getActivateEmailByToken(context, { key, config = {} }) {
            return base.request.get(`${baseUrl}/activate-email-by-token`, { params: { key: key }, ...config });
        },
        hasIdCard(context, { idCard, idIgnore, config }) {
            return base.request.post(`${baseUrl}/has-id-card`, { idCard, id: idIgnore }, { ...config });
        },
    },
    mutations: {
        ...base.mutations
    },
}
